import { IConcreteResourceCache } from '../engine/IResourceCache';
import { Platform } from '../engine/Platform';
import { Rect } from '../engine/Rect';
import { RenderSupport } from '../engine/RenderSupport';
import { SceneBuilder } from '../engine/SceneBuilder';
import { SceneObjectFactory } from '../engine/SceneObjectFactory';
import { SoundFactory } from '../engine/SoundFactory';
import { DefaultBlendResources } from '../engine/DefaultBlendResources';

export abstract class Application {
  protected platform: Platform;
  private _sceneBuilder: SceneBuilder;
  private _soundManager: SoundFactory;
  private _renderSupport: RenderSupport;
  private _resourceCache: IConcreteResourceCache;

  public buildApp(
    platform: Platform,
    resourceCache: IConcreteResourceCache,
    coordinateSystem: Rect
  ) {
    this.platform = platform;
    this._resourceCache = resourceCache;
    this._soundManager = new SoundFactory(platform.audioSystem.audioDevice);

    if (platform.videoSystem.isWebGL) {
      this._renderSupport = new RenderSupport(resourceCache, platform.videoSystem.renderDevice);
    } else {
      this._renderSupport = new RenderSupport(resourceCache, platform.videoSystem.renderDevice);
    }

    DefaultBlendResources.createDefaultBlendResources(
      resourceCache,
      platform.videoSystem.renderDevice
    );

    const sceneObjectFactory = new SceneObjectFactory(
      this._soundManager,
      platform.videoSystem.renderDevice,
      platform.view.canvas,
      platform,
      this._renderSupport
    );

    this._sceneBuilder = new SceneBuilder(sceneObjectFactory, coordinateSystem);
  }

  public get sceneBuilder(): SceneBuilder {
    return this._sceneBuilder;
  }

  public get soundManager(): SoundFactory {
    return this._soundManager;
  }

  public get renderSupport(): RenderSupport {
    return this._renderSupport;
  }

  public get resourceCache(): IConcreteResourceCache {
    return this._resourceCache;
  }

  abstract loadResources(): Promise<void>;

  abstract onAppReady(): void;

  abstract update(dt: number): void;

  abstract draw(): void;

  abstract activate(active: boolean): void;

  abstract contextLost(): void;

  abstract contextReady(): Promise<void>;

  public handleContextNotRestored(): void {
    window.location.assign(window.location.href);
  }
}
